export default __webpack_public_path__ + "static/media/pp (1).ca9a2911.jfif";